import request from "@utils/request";

export function getProfitLoss (query) {
    return request({
        url: "search/profit-loss",
        method: "post",
        data: query
    });
}